import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';

import { onReset } from 'src/app/authentication/reset-reducer';
import * as userPasswordResetRequestActions from './user-password-reset-request.actions';

export const userPasswordResetRequestFeatureKey = 'userPasswordResetRequest';

export interface UserPasswordResetRequestState {
   callState: CallState;
}

export const initialState: UserPasswordResetRequestState = {
   callState: LoadingState.Init,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),

   on(userPasswordResetRequestActions.submitUserPasswordResetRequest, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),

   on(
      userPasswordResetRequestActions.submitUserPasswordResetRequestSuccess,
      userPasswordResetRequestActions.submitUserPasswordResetRequestFailure,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   )
);
